var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DefaultErrorFromJSON } from '@amzn/handshake-painter-typescript-client/v1';
import { handleParzivalGatewayError } from 'src/utils/auth';
const HTTP_HEADERS = {
    CONTENT_TYPE: 'content-type',
};
const MEDIA_TYPES = {
    PROBLEM_JSON: 'application/problem+json',
};
export const fetchApiInterceptor = (url, init) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    // Get current page search params
    const currentSearchParams = new URLSearchParams(window.location.search);
    // Create URL object to modify
    const requestUrl = new URL(url.toString(), window.location.origin);
    // Add all current search params to the request URL
    currentSearchParams.forEach((value, key) => {
        if (!requestUrl.searchParams.has(key)) {
            requestUrl.searchParams.set(key, value);
        }
    });
    const response = yield fetch(requestUrl.toString(), init);
    if (!response.ok) {
        // Check if this is an init API call (matches pattern: /api/app/{version}/init)
        const isInitApi = /\/api\/app\/.*\/init/.test(requestUrl.pathname);
        try {
            yield handleParzivalGatewayError(response);
        }
        catch (error) {
            // Authentication error handling strategy:
            // - For init API: Let the AppError component handle reauthentication
            // - For other APIs: Reload the page to trigger a fresh init call which will handle authentication
            if (!isInitApi) {
                window.location.reload();
            }
            throw error;
        }
        if ((_a = response.headers.get(HTTP_HEADERS.CONTENT_TYPE)) === null || _a === void 0 ? void 0 : _a.includes(MEDIA_TYPES.PROBLEM_JSON)) {
            throw DefaultErrorFromJSON(yield response.json());
        }
        else {
            throw {
                status: response.status,
                title: response.statusText,
                detail: yield response.text(),
            };
        }
    }
    return response;
});
